var _ellipse, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8VirusFree50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 61,
    opacity: 0.3,
    rx: 20,
    ry: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#98c900",
    d: "M52.207,34.087c-1.523-0.446-3.552-1.041-5.795-1.698c-0.83-0.243-1.407-0.996-1.432-1.86 c-0.065-2.22-0.64-4.284-1.626-6.123c-0.411-0.766-0.294-1.707,0.306-2.335c1.608-1.686,3.062-3.211,4.154-4.357l-3.537-3.535 c-1.145,1.093-2.67,2.548-4.355,4.157c-0.629,0.6-1.57,0.717-2.336,0.307c-1.831-0.981-3.894-1.559-6.125-1.622 c-0.864-0.025-1.617-0.602-1.86-1.431c-0.659-2.242-1.254-4.271-1.702-5.793l-4.828,1.295c0.375,1.542,0.875,3.597,1.427,5.869 c0.204,0.84-0.159,1.712-0.893,2.17c-1.815,1.132-3.349,2.668-4.481,4.483c-0.457,0.734-1.329,1.098-2.169,0.894 c-2.272-0.551-4.327-1.05-5.87-1.424l-1.293,4.831c1.523,0.446,3.552,1.041,5.795,1.698c0.83,0.243,1.407,0.996,1.432,1.86 c0.065,2.22,0.64,4.284,1.626,6.123c0.411,0.766,0.294,1.707-0.306,2.335c-1.608,1.686-3.062,3.211-4.154,4.357l3.537,3.535 c1.145-1.093,2.67-2.548,4.355-4.157c0.629-0.6,1.57-0.717,2.336-0.307c1.831,0.981,3.894,1.559,6.125,1.622 c0.864,0.025,1.617,0.602,1.86,1.431c0.659,2.242,1.254,4.271,1.702,5.793l4.828-1.295c-0.375-1.542-0.875-3.597-1.427-5.869 c-0.204-0.84,0.159-1.712,0.893-2.17c1.815-1.133,3.349-2.668,4.481-4.483c0.457-0.734,1.329-1.098,2.169-0.894 c2.272,0.551,4.327,1.05,5.87,1.424L52.207,34.087z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 10.5,
    r: 4.5,
    fill: "#548500"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 29.5,
    r: 4.5,
    fill: "#548500"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 26.5,
    r: 2.5,
    fill: "#548500"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 37,
    r: 3,
    fill: "#548500"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.496,
    cy: 25.513,
    r: 4.5,
    fill: "#548500"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.996,
    cy: 46.013,
    r: 4.5,
    fill: "#548500"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 51.5,
    r: 4.5,
    fill: "#548500"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.504,
    cy: 36.487,
    r: 4.5,
    fill: "#548500"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.004,
    cy: 15.987,
    r: 4.5,
    fill: "#548500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4,38.74c-1.24,2.15-3.99,2.89-6.15,1.64c-0.94-0.54-1.6-1.39-1.95-2.34 c-0.72-0.17-1.47-0.35-2.26-0.55c-0.84-0.2-1.71,0.16-2.16,0.9c-1.14,1.81-2.67,3.35-4.49,4.48c-0.73,0.46-1.09,1.33-0.89,2.17 c0.19,0.79,0.37,1.53,0.55,2.25C39.77,47.92,41,49.56,41,51.5c0,2.49-2.01,4.5-4.5,4.5S32,53.99,32,51.5c0-1.09,0.41-2.08,1.05-2.86 c-0.21-0.72-0.42-1.45-0.65-2.23c-0.24-0.83-1-1.41-1.86-1.43c-1.74-0.05-3.38-0.41-4.89-1.04c0.48-2.27,2.5-3.96,4.89-3.96h0.14 c1.04,0.03,2.04,0.29,2.93,0.73c0.54-0.82,1.26-1.53,2.14-2.08c1.16-0.73,2.16-1.72,2.88-2.89c0.55-0.87,1.26-1.6,2.08-2.14 c-0.44-0.89-0.7-1.88-0.73-2.93c-0.07-2.44,1.63-4.54,3.95-5.03c0.63,1.51,1,3.15,1.05,4.89c0.03,0.86,0.6,1.62,1.43,1.86 c0.78,0.23,1.51,0.44,2.22,0.65c1.41-1.17,3.45-1.42,5.12-0.45C55.91,33.83,56.64,36.58,55.4,38.74z",
    opacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.35,18.06c-0.48,2.27-2.5,3.96-4.89,3.96h-0.14c-1.04-0.03-2.04-0.29-2.93-0.73 c-0.54,0.82-1.26,1.53-2.14,2.08c-1.16,0.73-2.16,1.72-2.88,2.89c-0.55,0.87-1.26,1.6-2.08,2.14c0.44,0.89,0.7,1.88,0.73,2.93 c0.07,2.44-1.63,4.54-3.95,5.03c-0.63-1.51-1-3.15-1.05-4.89c-0.03-0.86-0.6-1.62-1.43-1.86c-0.78-0.23-1.51-0.44-2.22-0.65 c-1.41,1.17-3.45,1.42-5.12,0.45c-2.16-1.24-2.89-3.99-1.65-6.15c1.24-2.15,3.99-2.89,6.15-1.64c0.94,0.54,1.6,1.39,1.95,2.34 c0.72,0.17,1.47,0.35,2.26,0.55c0.84,0.2,1.71-0.16,2.16-0.9c1.14-1.81,2.67-3.35,4.49-4.48c0.73-0.46,1.09-1.33,0.89-2.17 c-0.19-0.79-0.37-1.53-0.55-2.25C22.23,14.08,21,12.44,21,10.5C21,8.01,23.01,6,25.5,6S30,8.01,30,10.5c0,1.09-0.41,2.08-1.05,2.86 c0.21,0.72,0.42,1.45,0.65,2.23c0.24,0.83,1,1.4,1.86,1.43C33.2,17.07,34.84,17.43,36.35,18.06z",
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.5,12c-0.828,0-1.5-0.672-1.5-1.5C22,8.668,23.668,7,25.5,7C26.328,7,27,7.672,27,8.5 S26.328,10,25.5,10c-0.173,0-0.5,0.327-0.5,0.5C25,11.328,24.328,12,23.5,12z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.5,27C7.672,27,7,26.328,7,25.5c0-1.832,1.668-3.5,3.5-3.5c0.828,0,1.5,0.672,1.5,1.5 S11.328,25,10.5,25c-0.173,0-0.5,0.327-0.5,0.5C10,26.328,9.328,27,8.5,27z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14,47.5c-0.828,0-1.5-0.672-1.5-1.5c0-1.832,1.668-3.5,3.5-3.5c0.828,0,1.5,0.672,1.5,1.5 s-0.672,1.5-1.5,1.5c-0.173,0-0.5,0.327-0.5,0.5C15.5,46.828,14.828,47.5,14,47.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.5,53c-0.828,0-1.5-0.672-1.5-1.5c0-1.832,1.668-3.5,3.5-3.5c0.828,0,1.5,0.672,1.5,1.5 S37.328,51,36.5,51c-0.173,0-0.5,0.327-0.5,0.5C36,52.328,35.328,53,34.5,53z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M49.5,38c-0.828,0-1.5-0.672-1.5-1.5c0-1.832,1.668-3.5,3.5-3.5c0.828,0,1.5,0.672,1.5,1.5 S52.328,36,51.5,36c-0.173,0-0.5,0.327-0.5,0.5C51,37.328,50.328,38,49.5,38z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44,17.5c-0.828,0-1.5-0.672-1.5-1.5c0-1.832,1.668-3.5,3.5-3.5c0.828,0,1.5,0.672,1.5,1.5 s-0.672,1.5-1.5,1.5c-0.173,0-0.5,0.327-0.5,0.5C45.5,16.828,44.828,17.5,44,17.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd3c4f",
    d: "M55.5,58c-0.64,0-1.279-0.244-1.768-0.732l-47-47c-0.977-0.977-0.977-2.559,0-3.535 s2.559-0.977,3.535,0l47,47c0.977,0.977,0.977,2.559,0,3.535C56.779,57.756,56.14,58,55.5,58z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8VirusFree50);
export default __webpack_public_path__ + "static/media/icons8-virus-free-50.4574cdc1af4ffc7bacfe4c50b0db95b2.svg";
export { ForwardRef as ReactComponent };